/* ============================================================================
   PURE SEA MOSS — caja de compra de la PDP
   Portado de BuyBox.tsx (Astro) el 2026-09-14.

   Elige la variante a partir de los radios de Formato y Talla, muestra u
   oculta los planes de recarga que existen para esa variante (hoy solo los
   pouches) y pinta el importe de lo que el cliente va a firmar ANTES de que
   añada: precio de recarga, precio suelto tachado y la cadencia.

   El añadido al carrito lo hace cart-drawer.js, que intercepta cualquier
   <form action="/cart/add">. Aquí solo se mantiene el formulario coherente.
   ========================================================================== */

(() => {
  const sections = document.querySelectorAll('[data-product-section]');

  const formatMoney = (cents, format) => {
    const value = (cents / 100).toFixed(2);
    const [whole, decimals] = value.split('.');
    const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace('{{amount_no_decimals}}', withCommas)
      .replace('{{amount}}', `${withCommas}.${decimals}`)
      .replace(/\{\{\s*\w+\s*\}\}/, `${withCommas}.${decimals}`);
  };

  sections.forEach((section) => {
    const data = JSON.parse(section.querySelector('[data-product-json]').textContent);
    const form = section.querySelector('form[action$="/cart/add"]');
    if (!form) return;

    const idInput = form.querySelector('[data-variant-id]');
    const priceNow = form.querySelector('[data-price-now]');
    const priceWas = form.querySelector('[data-price-was]');
    const cadence = form.querySelector('[data-cadence]');
    const addButton = form.querySelector('[data-add]');
    const addLabel = addButton.querySelector('[data-label]');
    const planGroup = form.querySelector('[data-plan-group]');

    const selectedOptions = () => {
      const values = [];
      form.querySelectorAll('[data-option-index]').forEach((input) => {
        if (input.type === 'radio' && !input.checked) return;
        values[Number(input.dataset.optionIndex)] = input.value;
      });
      return values;
    };

    const findVariant = (options) =>
      data.variants.find((v) => v.options.every((value, i) => value === options[i]));

    const selectedPlan = () => form.querySelector('[data-plan-input]:checked')?.value || '';

    const update = () => {
      const variant = findVariant(selectedOptions());

      if (!variant) {
        addButton.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }

      idInput.value = variant.id;

      // Solo los planes que existen para ESTA variante. Si el plan elegido no
      // existe aquí (se pasó de pouch a tarro), se vuelve a "Just once".
      if (planGroup) {
        const planIds = Object.keys(variant.plans);
        planGroup.hidden = planIds.length === 0;
        planGroup.querySelectorAll('[data-plan]').forEach((label) => {
          const exists = planIds.includes(label.dataset.plan);
          label.hidden = !exists;
          if (!exists) label.querySelector('input').checked = false;
        });
        if (!form.querySelector('[data-plan-input]:checked')) {
          const once = planGroup.querySelector('[data-plan-input][value=""]');
          if (once) once.checked = true;
        }
      }

      const plan = selectedPlan();
      const planPrice = plan ? variant.plans[plan] : null;

      if (planPrice != null) {
        priceNow.textContent = formatMoney(planPrice, data.moneyFormat);
        if (planPrice < variant.price) {
          priceWas.textContent = `${formatMoney(variant.price, data.moneyFormat)} once`;
          priceWas.hidden = false;
        } else {
          priceWas.hidden = true;
        }
        cadence.textContent = `${data.planNames[plan]}. Charged each time it ships — skip, change or cancel from your account.`;
        cadence.hidden = false;
      } else {
        priceNow.textContent = formatMoney(variant.price, data.moneyFormat);
        priceWas.hidden = true;
        cadence.hidden = true;
      }

      addButton.disabled = !variant.available;
      addLabel.textContent = !variant.available
        ? 'Sold out'
        : planPrice != null
          ? 'Start the refill'
          : 'Add to cart';

      // La URL refleja la variante, para compartirla o volver a ella.
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    form.addEventListener('change', (event) => {
      if (event.target.matches('[data-option-index], [data-plan-input]')) update();
    });
    update();
  });
})();
